import extractBackgroundOverlays from '@activebrands/core-web/libs/storyblok/utils/extract-background-overlays';
import transformFlexibleBackgrounds from '@activebrands/core-web/libs/storyblok/utils/transform-flexible-backgrounds';
import transformHeading from '@activebrands/core-web/libs/storyblok/utils/transform-heading';
import Highlight from 'components/content-components/Highlight';
import transformAnchorTag from '@activebrands/core-web/libs/storyblok/utils/transform-anchor-tag';
import transformTag from '@activebrands/core-web/libs/storyblok/utils/transform-tag';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';

const HighlightDataTransformerBlock = ({ content }: any) => {
    const { _editable, anchorTag, links, tag, heading } = content;

    if (!links.length) {
        return null;
    }

    const transformedLinks = links.map(linkitem => {
        const { backgroundMobile, backgroundDesktop, } = linkitem;

        const transformedBackgrounds = transformFlexibleBackgrounds(
			[backgroundMobile?.[0], null, null, null, backgroundDesktop?.[0]],
			[0.77, null, 0.31 , null, 0.20] 
        );

        const backgroundOverlays = extractBackgroundOverlays([
            backgroundMobile?.[0],
            null,
            null,
            null,
            backgroundDesktop?.[0],
        ]);

        return {
            background: transformedBackgrounds,
            backgroundOverlay: backgroundOverlays,
            component: linkitem.component,
            follow: linkitem.follow,
            label: linkitem.label,
            link: linkitem.link,
            sbEditable: transformPreviewEditable(linkitem._editable),
            uid: linkitem._uid,
        };
    });

    return (
        <Highlight
            heading={transformHeading({ heading, defaultType: 'h3' })}
            id={transformAnchorTag({ anchorTag })}
            items={transformedLinks}
            sbEditable={transformPreviewEditable(_editable)}
            slidesPerView={[1.3, null, 3.2, null, null, 5]}
            tag={transformTag({ tag })}
            type="highlight"
        />
    );
};
export default HighlightDataTransformerBlock;
